<template>
  <div :class="'summary-body'">
    <div class="summary-detail">
      <p class="summary-detail__text">
        満年齢（2025年7月1日時点）：{{ age }}歳<br />性別：{{ gender
        }}<br />ライフステージ：{{ getLifestage }}
      </p>
      <button type="button" class="summary-detail__btn" @click="move('main')">
        変更する
      </button>
    </div>
  </div>
</template>

<script>
import { GENDER_LABELS, PERSON_LABELS, LIFESTAGE_LABELS } from "@/const.js";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "OptionsSummaryBody",
  components: {},
  props: {
    pid: String,
  },
  data() {
    return {
      personId: this.pid,
      age: this.$store.getters.getPerson(this.pid).age,
      gender: this.$store.getters.getPerson(this.pid).gender,
      //getterはcomputedにマッピングされcomputedは引数をとれない(がんばれば取れなくもないが)ので上記のように$storeから書かざるを得ない
    };
  },
  computed: {
    ...mapGetters(["getLifestage"]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
  },
};
</script>

<style scoped lang="scss">
.summary {
  &-body {
    background-color: #fff;
    border: 1px solid $color-bg-footer;
    border-radius: 4px;
    @include pc {
      padding: 20px 40px;
    }
    @include sp{
      padding: 20px;
    }
  }
  &-detail {
    &__btn {
      display: block;
      font-weight: 800;
      background-color: #215783;
      color: #fff;
      width: 100%;
      @include pc {
        margin: 20px auto 0;
        padding: 5px 20px;
      }
      @include sp {
        margin: 10px auto 0;
        padding: 5px 10px;
      }
    }
  }
}
</style>